import styled from 'styled-components';
import { su } from '../utils/styledComponents';

const Paragraph = styled.p`
  margin-bottom: ${su(2)};
`;
export default Paragraph;
